import React, { useState, useMemo } from 'react';

import PlayCircleIcon from '@heroicons/react/24/solid/PlayCircleIcon';
import ReactPlayer from 'react-player';

import useWindowDimensions from '../../../_navigation/hooks/use-window-dimensions';
interface VideoPlayerProps {
  url: string;
  onComplete: () => void;
  isOnBoarding?: boolean;
}
export const VideoPlayer: React.FC<VideoPlayerProps> = ({ url, onComplete, isOnBoarding }) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const { height: windowHeight } = useWindowDimensions();

  const playerHeight = useMemo(() => {
    if (isOnBoarding) {
      const headerHeight = 128;
      const availableHeight = Math.min(windowHeight - headerHeight, 706);

      return `${availableHeight}px`;
    }
    return '100%';
  }, [windowHeight, isOnBoarding]);

  const handleTogglePlay = () => {
    setIsPlaying((prev) => !prev);
  };
  const handleComplete = () => {
    setIsPlaying(false);
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
    onComplete();
  };
  return (
    <div className={`relative w-full overflow-hidden rounded-xl bg-black`}>
      <ReactPlayer
        width="100%"
        height={playerHeight}
        url={url}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={handleComplete}
        playing={isPlaying}
        controls={true}
      />

      {!isPlaying && (
        <div
          className="absolute inset-0 z-20 flex cursor-pointer items-center justify-center"
          onClick={handleTogglePlay}
        >
          <div className="rounded-full bg-white">
            <PlayCircleIcon className="h-24 w-24 text-primary" />
          </div>
        </div>
      )}
    </div>
  );
};
